const define = (tagName, options) => {
  return (classRef) => customElements.define(tagName, classRef, options);
};

export default define;
